export default {
  data: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/company_settings/state.js